/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import localforage from "localforage";
import { applyMiddleware, createStore, Middleware } from "redux";
import { createLogger } from "redux-logger";
import { createEpicMiddleware } from "redux-observable";
import { createMigrate, PersistConfig, persistReducer, persistStore } from "redux-persist";
import { ActionType } from "typesafe-actions";
import { AppAction, AppState, followUpsTransform, rootEpic, rootReducer } from "../redux";

export default function configureStore() {
  const epicMiddleware = createEpicMiddleware<
    AppAction,
    ActionType<any>,
    AppState,
    any
  >();

  localforage.config({
    name: "DairyFARM DB",
    driver: [
      localforage.INDEXEDDB,
      localforage.WEBSQL,
      localforage.LOCALSTORAGE,
    ],
    storeName: "nmpf",
    version: 3,
  });

  const persistConfig: PersistConfig = {
    key: "entities",
    storage: localforage,
    whitelist: ["session", "followUps", "facilities", "coops", "farms"],
    migrate: createMigrate({
      2: (state) => {
        return {...state, forms: undefined}
      },
      3: (state) => {
        return { ...state, evals: undefined  }
      },
    }),
    transforms: [followUpsTransform]
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const middlewares: Middleware[] = [epicMiddleware];
  // if (process.env.NODE_ENV !== "production") {
  //   middlewares.push(createLogger());
  // }

  const store = createStore(
    persistedReducer,
    undefined,
    applyMiddleware(...middlewares)
  );

  const persistor = persistStore(store);

  epicMiddleware.run(rootEpic as any);

  return { store, persistor };
}
